import React from 'react'

export default (props) => <>{props.children}</>
